var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 6.875C11.7594 6.875 12.375 6.25939 12.375 5.5C12.375 4.74061 11.7594 4.125 11 4.125C10.2406 4.125 9.625 4.74061 9.625 5.5C9.625 6.25939 10.2406 6.875 11 6.875Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.375C11.7594 12.375 12.375 11.7594 12.375 11C12.375 10.2406 11.7594 9.625 11 9.625C10.2406 9.625 9.625 10.2406 9.625 11C9.625 11.7594 10.2406 12.375 11 12.375Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.4166C11.7594 17.4166 12.375 16.801 12.375 16.0416C12.375 15.2822 11.7594 14.6666 11 14.6666C10.2406 14.6666 9.625 15.2822 9.625 16.0416C9.625 16.801 10.2406 17.4166 11 17.4166Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThreeDots);
export default __webpack_public_path__ + "static/media/icon-three-dots.e46e0cccb9c0cf26f3fcee63078648b2.svg";
export { ForwardRef as ReactComponent };